import { IonBadge, IonList } from "@ionic/react";
import React from "react";
import { connect } from "react-redux";
import UserPhaseListItem from "./UserPhaseListItem";

interface props {
	user: any;
	entries: any;
}

const UserPhaseList: React.FC<props> = ({ user, entries }) => {
	const _sortPhases = (a: any, b: any) => {
		return a.pOrder - b.pOrder;
	};

	const _checkPhaseEntriesComplete = (phase: any) => {
		let complete = true;

		const dayMS = 86400000;
		let startTS = Date.parse(phase.pStart + "T00:00:00");
		let endTS = new Date(phase.pEnd).getTime();
		let TS = startTS;

		while (TS <= endTS) {
			let entry: any = Object.values(entries).find(
				(el: any) => parseInt(el.dateTS) === TS
			);

			if (!entry || (entry && !entry.complete)) {
				complete = false;
			}

			TS = TS + dayMS;
		}

		return complete;
	};

	const _phaseStatus = (phase: any) => {
		let date = new Date().getTime();
		let startDate = Date.parse(phase.pStart + "T00:00:00");
		let endDate = Date.parse(phase.pEnd + "T00:00:00");

		let color = "";
		let text = "";

		let complete = _checkPhaseEntriesComplete(phase);

		//check that all dates in this range have completed entries
		if (endDate < date) {
			if (complete) {
				color = "success";
				text = "Completed";
			} else {
				color = "danger";
				text = "Incomplete";
			}
		} else if (endDate >= date && startDate <= date) {
			color = "warning";
			text = "Current";
		} else if (startDate > date) {
			color = "light";
			text = "Upcoming";
		}

		return <IonBadge color={color}>{text}</IonBadge>;
	};

	const _phaseDates = (phase: any) => {
		const options: any = {
			year: "numeric",
			month: "short",
			day: "numeric",
		};
		//eslint-disable-next-line
		let startDate = new Date(phase.pStart).toLocaleDateString("en-NZ", options);
		let endDate = new Date(phase.pEnd).toLocaleDateString("en-NZ", options);

		return `${startDate} - ${endDate}`;
	};

	const _phaseNotes = (phase: any) => {
		return phase.pNote;
	};

	return (
		<>
			{user.phases &&
				Object.values(user.phases).length > 0 &&
				Object.values(user.phases.sort(_sortPhases)).map(
					(phase: any, idx: any) => (
						<UserPhaseListItem
							label={phase.pLabel}
							status={_phaseStatus(phase)}
							dates={_phaseDates(phase)}
							notes={_phaseNotes(phase)}
							key={idx}
						/>
					)
				)}
		</>
	);
};

export default UserPhaseList;
